import PrivateRoute from "./Pages/PrivateRoute/PrivateRoute";
import MainRoute from "./Pages/PrivateRoute/MainRoute";
import Onboarding from "./Pages/Onboarding/Onboarding";
import Home from "./Pages/Home/Home";
import LoginOrRegister from "./Pages/LoginOrRegister/LoginOrRegister";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import VerificationCode from "./Pages/VerificationCode/VerificationCode";
import Welcome from "./Pages/Welcome/Welcome";
import Goals from "./Pages/Goals/Goals";
import Activities from "./Pages/Activities/Activities";
import Age from "./Pages/Age/Age";
import Height from "./Pages/Height/Height";
import Weight from "./Pages/Weight/Weight";
import Start from "./Pages/Start/Start";
import DownloadFile from "./Pages/DownloadFile/DownloadFile";
import Tickets from "./Pages/Tickets/Tickets";
import Chat from "./Pages/Tickets/Chat/Chat";
import EditProfile from "./Pages/EditProfile/EditProfile";
import ChangeNumber from "./Pages/ChangeNumber/ChangeNumber";
import Setting from "./Pages/Setting/Setting";
import Guide from "./Pages/Guide/Guide";
import Coins from "./Pages/Coins/Coins";
import ChargeCoin from "./Pages/ChargeCoin/ChargeCoin";
import SportClasses from "./Pages/SportClasses/SportClasses";
import Exercise from "./Pages/Exercise/Exercise";
import CoursePayment from "./Pages/CoursePayment/CoursePayment";
import SelfCoaching from "./Pages/SelfCoaching/SelfCoaching";
import BodyBuildingCoaching from "./Pages/SelfCoaching/BodyBuildingCoaching/BodyBuildingCoaching";
import OfflineClasses from "./Pages/OfflineClasses/OfflineClasses";
import Shop from "./Pages/Shop/Shop";
import HealthGoals from "./Pages/HealthGoals/HealthGoals";
import DietsProgram from "./Pages/DietsProgram/DietsProgram";
import Challenge from "./Pages/Challenge/Challenge";
import Magazines from "./Pages/Magazines/Magazines";
import Magazine from "./Pages/Magazines/Magazine/Magazine";
import OnlineCalculator from "./Pages/OnlineCalculator/OnlineCalculator";
import CalorieCounter from "./Pages/CalorieCounter/CalorieCounter";
import UserProfilePanel from "./Pages/UserProfilePanel/UserProfilePanel";
import NewTicket from "./Pages/Tickets/NewTicket/NewTicket";
import Skeleton from "./Pages/OnlineCalculator/Skeleton/Skeleton";
import WaistToHip from "./Pages/OnlineCalculator/WaistToHip/WaistToHip";
import BMI from "./Pages/OnlineCalculator/BMI/BMI";
import Metabolism from "./Pages/OnlineCalculator/Metabolism/Metabolism";
import MealCalorie from "./Pages/CalorieCounter/MealCalorie/MealCalorie";
import FoodList from "./Pages/CalorieCounter/MealCalorie/FoodList/FoodList";
import Charts from "./Pages/Charts/Charts";
import Video from "./Pages/Video/Video";
import MonthlyReport from "./Pages/MonthlyReport/MonthlyReport";
import MedicalForm from "./Pages/MedicalForm/MedicalForm";
import UploadUserImg from "./Pages/UploadUserImg/UploadUserImg";
import BodyMeasurements from "./Pages/BodyMeasurements/BodyMeasurements";
import CompleteForm from "./Pages/CompleteForm/CompleteForm";
import ClassVideo from "./Pages/ClassVideo/ClassVideo";
import ClassFeedback from "./Pages/ClassFeedback/ClassFeedback";
import ProductsCategory from "./Pages/Shop/ProductsCategory/ProductsCategory";
import PartialProducts from "./Pages/Shop/PartialProducts/PartialProducts";
import Product from "./Pages/Shop/Product/Product";
import Cart from "./Pages/Shop/Cart/Cart";
import ShopPayment from "./Pages/Shop/ShopPayment/ShopPayment";
import Favorites from "./Pages/Shop/Favorites/Favorites";
import ProductFilter from "./Pages/Shop/ProductFilter/ProductFilter";
import NutritionFeedback from "./Pages/NutritionFeedback/NutritionFeedback";
import MealsForms from "./Pages/MealsForms/MealsForms";
import SubFilter from "./Pages/Shop/ProductFilter/SubFilter/SubFilter";
import ProductsSearch from "./Pages/Shop/ShopSearch/ProductsSearch";
import Gallery from "./Pages/Shop/Gallery/Gallery";

let routes = [
  {
    path: "/*",
    element: <PrivateRoute />,
    children: [
      { path: "home", element: <Home /> },
      { path: "userPanel", element: <UserProfilePanel /> },
      { path: "goals", element: <Goals /> },
      { path: "activities", element: <Activities /> },
      { path: "age", element: <Age /> },
      { path: "height", element: <Height /> },
      { path: "weight", element: <Weight /> },
      { path: "start", element: <Start /> },
      { path: "download", element: <DownloadFile /> },
      { path: "tickets", element: <Tickets /> },
      { path: "ticket/:id", element: <Chat /> },
      { path: "editProfile", element: <EditProfile /> },
      { path: "changeNumber", element: <ChangeNumber /> },
      { path: "setting", element: <Setting /> },
      { path: "guide", element: <Guide /> },
      { path: "coins", element: <Coins /> },
      { path: "chargeCoin", element: <ChargeCoin /> },
      { path: "sportClasses", element: <SportClasses /> },
      { path: "exercise", element: <Exercise /> },
      { path: "coursePayment", element: <CoursePayment /> },
      { path: "selfCoaching", element: <SelfCoaching /> },
      { path: "bodyBuildingCoaching", element: <BodyBuildingCoaching /> },
      { path: "offlineClasses", element: <OfflineClasses /> },
      { path: "shop", element: <Shop /> },
      { path: "health", element: <HealthGoals /> },
      { path: "diets", element: <DietsProgram /> },
      { path: "challenge", element: <Challenge /> },
      { path: "magazines", element: <Magazines /> },
      { path: "magazine", element: <Magazine /> },
      { path: "calculator", element: <OnlineCalculator /> },
      { path: "calorieCounter", element: <CalorieCounter /> },
      { path: "newTicket", element: <NewTicket /> },
      { path: "skeleton", element: <Skeleton /> },
      { path: "waistToHip", element: <WaistToHip /> },
      { path: "bmi", element: <BMI /> },
      { path: "metabolism", element: <Metabolism /> },
      {
        path: "mealCalorieSelector/:id",
        element: <MealCalorie />,
        children: [{ path: "foodList", element: <FoodList /> }],
      },
      { path: "charts", element: <Charts /> },
      { path: "video", element: <Video /> },
      { path: "monthlyReport", element: <MonthlyReport /> },
      { path: "medicalForm", element: <MedicalForm /> },
      { path: "uploadImage", element: <UploadUserImg /> },
      { path: "bodyMeasurements", element: <BodyMeasurements /> },
      { path: "completeForm", element: <CompleteForm /> },
      { path: "class", element: <ClassVideo /> },
      { path: "classFeedback", element: <ClassFeedback /> },
      { path: "productsCategory", element: <ProductsCategory /> },
      { path: "partialProducts", element: <PartialProducts /> },
      { path: "product", element: <Product /> },
      { path: "cart", element: <Cart /> },
      { path: "shopPayment", element: <ShopPayment /> },
      { path: "favorites", element: <Favorites /> },
      { path: "productFilter", element: <ProductFilter /> },
      { path: "nutritionFeedback", element: <NutritionFeedback /> },
      { path: "mealsForms", element: <MealsForms /> },
      { path: "subFilter", element: <SubFilter /> },
      { path: "productsSearch", element: <ProductsSearch /> },
      { path: "gallery", element: <Gallery /> },
    ],
  },
  {
    path: "/",
    element: (
      <MainRoute>
        <Home />
      </MainRoute>
    ),
  },
  { path: "/onBoarding", element: <Onboarding /> },
  { path: "/loginOrRegister", element: <LoginOrRegister /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/verificationCode", element: <VerificationCode /> },
  { path: "/welcome", element: <Welcome /> },
];

export default routes;
